'use strict';

/* jshint -W098 */
angular.module('mean.bids').controller('TradesBidController', ['$scope', 'Global', 'Bids', '$filter', '$sce', 'toaster', 'NotifyService', 'BidRequestReview', '$http', 'CompanyFactors', 'Projects', 'ProjectBids', '$location', 'ProjectJobs', 'BidOldReview', 'MeanUser', 'tradeCodeService', 'taskTotalsService', 'userService', 'BidRequestEdit', 'Builders', 'Trades', 'BidBuilderReview', 'BidWizardEdit', 'TradeBids', 'ngDialog', 'optionSaveService', 'projectCompleteService',
    function ($scope, Global, Bids, $filter, $sce, toaster, NotifyService, BidRequestReview, $http, CompanyFactors, Projects, ProjectBids, $location, ProjectJobs, BidOldReview, MeanUser, tradeCodeService, taskTotalsService, userService, BidRequestEdit, Builders, Trades, BidBuilderReview, BidWizardEdit, TradeBids, ngDialog, optionSaveService, projectCompleteService) {
        $scope.global = Global;
        $scope.package = {
            name: 'bids'
        };

        if (!MeanUser.user._id) {
            $location.path('/');
            return;
        }

        $scope.user = MeanUser.user;
        $scope.is_admin = userService.isAdmin($scope.user);
        if (!$scope.is_admin) {
            $scope.is_admin = userService.isOffice($scope.user);
        }
        $scope.is_trade = true;

        $scope.sortReqType = ['bid_name'];
        $scope.sortReqReverse = false;
        $scope.sortRevType = ['bid_name'];
        $scope.sortRevReverse = false;
        $scope.sortProjectType = ['project_name'];
        $scope.sortProjectReverse = false;
        $scope.sortRejectedType = ['bid_name'];
        $scope.sortRejectedReverse = false;
        $scope.sortClosedType = ['bid_name'];
        $scope.sortClosedReverse = false;

        $scope.pop = function () {
            toaster.pop('success', 'title', 'text');
        };

        $scope.editId = 1;

        userService.getMainAccountId($scope.user.username).then(function (result) {
            $scope.main_account_id = result;
            Trades.query({ 'main_account_id': result }, function (trades) {
                if (trades.length !== 1) {
                    toaster.pop('error', 'Trade', 'There is a problem getting the trade from the database');
                    return;
                }
                $scope.trade = trades[0];
                var bids = [];
                //this search will look for all the bids that are assigned to me
                Bids.query({
                    'type': 'UserBids',
                    'populate': true,
                    'username': $scope.trade.main_account_id.username
                }, function (bids) {
                    //this will look for all bids that are mine but i have not
                    //assigned myself yet.  Most of the time this should be 0
                    //but there may be case where a bid is created and
                    //it will take some time to set my trade as the bidding trade.
                    Bids.query({
                        'type': 'UserBidsNoTradeSet',
                        'trade_id': $scope.trade._id
                    }, function (trade_bids) {

                        _.each(trade_bids, function (trade_bid) {
                            bids.push(trade_bid);
                        });

                        $scope.rejected_bids = [];

                        $scope.rejected_bids = _.remove(bids, function (bid) {
                            if (bid.bidding_trades.length === 0) return false;
                            return bid.bidding_trades[0].rejected;
                        });

                        $scope.rejected_bids = $filter('orderBy')($scope.rejected_bids, 'bid_name');

                        $scope.new_bids = $filter('filter')(bids, { bid_status: 'new' });
                        $scope.submitted_bids = $filter('filter')(bids, { bid_status: 'submitted' });
                        $scope.review_bids = $filter('filter')(bids, { bid_status: 'review' }, true);
                        $scope.builder_bids = $filter('filter')(bids, { bid_status: 'builder_review' }, true);
                        $scope.project_bids = $filter('filter')(bids, { bid_status: 'project' });
                        $scope.complete = $filter('filter')(bids, { bid_status: 'complete' });

                        $scope.complete = $filter('orderBy')($scope.complete, 'bid_name');

                        for (var i = 0; i < $scope.submitted_bids.length;) {
                            var value = 0;

                            $scope.submitted_bids[i].builder = ($scope.submitted_bids[i].builder_id) ?
                                $scope.submitted_bids[i].builder_id.name : $scope.submitted_bids[i].trade_id.name;

                            var sub_bids = $filter('filter')($scope.submitted_bids[i].bidding_trades, { submitted: 'true' });
                            value = sub_bids.length / $scope.submitted_bids[i].bidding_trades.length;

                            $scope.submitted_bids[i].bid_request_progress = value * 100;

                            if ($scope.submitted_bids[i].bid_request_progress === 100) {
                                $scope.submitted_bids[i].bid_status = 'builder_review';
                                $scope.builder_bids.push($scope.submitted_bids[i]);
                                $scope.submitted_bids.splice(i, 1);
                            } else {
                                i = i + 1;
                            }
                        }

                        for (var i = 0; i < $scope.submitted_bids.length; i++) {
                            var bid = $scope.submitted_bids[i];
                            if (bid.plan_codes.length) {
                                bid.number_of_units = 0;
                                for (var j = 0; j < bid.plan_codes.length; j++) {
                                    if (bid.plan_codes[j].quantity)
                                        bid.number_of_units += bid.plan_codes[j].quantity;
                                }

                                if (bid.bidding_trades[0] &&
                                    bid.bidding_trades[0].first_process) {
                                    bid.status_text = 'Untouched';
                                } else {
                                    bid.status_text = 'In Progress';
                                }

                                var req_date = moment(bid.bid_date_requested);
                                var today = moment();
                                bid.days_diff = req_date.diff(today, 'days');

                                if (bid.days_diff >= 7) {
                                    bid.status_color = 'green';
                                } else if (bid.days_diff >= 0) {
                                    bid.status_color = 'yellow';
                                } else {
                                    bid.status_color = 'red';
                                }
                            }
                        }

                        for (var i = 0; i < $scope.builder_bids.length; i++) {
                            var bid = $scope.builder_bids[i];

                            if (bid.plan_codes.length) {
                                bid.number_of_units = 0;
                                for (var j = 0; j < bid.plan_codes.length; j++) {
                                    if (bid.plan_codes[j].quantity)
                                        bid.number_of_units += bid.plan_codes[j].quantity;
                                }
                            }
                        }

                        for (var i = 0; i < $scope.project_bids.length; i++) {
                            var bid = $scope.project_bids[i];

                            bid.builder = (bid.builder_id) ?
                                bid.builder_id.name : bid.trade_id.name;

                            if (bid.plan_codes.length) {
                                bid.number_of_units = 0;
                                for (var j = 0; j < bid.plan_codes.length; j++) {
                                    if (bid.plan_codes[j].quantity)
                                        bid.number_of_units += bid.plan_codes[j].quantity;
                                }
                            }
                        }

                        for (var i = 0; i < $scope.rejected_bids.length; i++) {
                            var bid = $scope.rejected_bids[i];

                            bid.builder = (bid.builder_id) ?
                                bid.builder_id.name : bid.trade_id.name;

                            var date = new Date(bid.bidding_trades[0].date_rejected);
                            bid.bidding_trades[0].date_rejected = $filter('date')(date, 'mediumDate');
                        }

                        for (var i = 0; i < $scope.complete.length; i++) {
                            var bid = $scope.complete[i];

                            bid.builder = (bid.builder_id) ?
                                bid.builder_id.name : bid.trade_id.name;

                            if(bid.bidding_trades[0] != null || typeof bid.bidding_trades[0] != 'undefined') {
                                var date = new Date(bid.bidding_trades[0].date_completed);
                                bid.date_completed = $filter('date')(date, 'mediumDate');
                            } else {
                                console.log('Bid: ' + bid.bid_name + 
                                    ' does not have a valid trade associated with it.');
                            }
                        }
                    });
                });
            });
        });

        $scope.editRequest = function () {

            var bid = $filter('filter')($scope.submitted_bids, {
                '_id': $scope.details_bid_id
            }, true);

            if (bid.length === 1) {
                BidRequestEdit.set(bid[0]);
            } else {
                toaster.pop('error', 'Trade Bid Requests',
                    'There was a problem getting the bid details.  Contact Admin.');
            }
        };

        $scope.editOptions = function () {

            var bid = $filter('filter')($scope.submitted_bids, {
                '_id': $scope.details_bid_id
            }, true);

            if (bid.length === 1) {
                BidRequestEdit.set(bid[0]);
            } else {
                toaster.pop('error', 'Trade Bid Requests Options',
                    'There was a problem getting the bid details.  Contact Admin.');
            }
        };

        $scope.addPlanToRequest = function(new_codes) {
            console.log(this);
            console.log($scope);

            if(!new_codes) return;

            var bid = $scope.bid;

            if(!bid) {
                toaster.pop('error', 'Trade Bid Requests',
                    'There was a problem getting the bid details.  Contact Admin.');
                return;
            }

            var current_codes = [];
            for(var i=0; i<bid.plan_codes.length; i++) {
                current_codes.push(bid.plan_codes[i].code);
            }

            var letterNumber = /^[0-9a-zA-Z]+$/;
            var goodInput = true;

            var array = new_codes.split(',');
            var removed = []
            for(var i=0; i<array.length; i++) {
                //remove any white space and make upper case
                array[i] = array[i].trim().replace(/\s/g, '').toUpperCase();
                //check for only alphanumeric
                if(!array[i].match(letterNumber)) {
                    removed.push(array[i]);
                }
                //check for duplicates already saved
                if(current_codes.indexOf(array[i]) !== -1) {
                    removed.push(array[i]);
                }
            }

            if(removed.length > 0) {
                //notify the user of code issues
                _.each(removed, function(item) {
                    if(item != '') {
                        toaster.pop('warning', 'Code Not Included', item);
                    } else {
                        toaster.pop('warning', 'Code Not Included', 'Empty Code String');
                    }
                });
            }

            for(var i=0; i<array.length; i++) {
                if(current_codes.indexOf(array[i]) === -1) {
                    //One final check to make sure we don't include an empty string
                    if(array[i] != '') {
                        bid.plan_codes.push({
                            'code': array[i],
                        });
                    }
                }
            }

            bid.$update(function(success) {
                BidRequestEdit.set(success);
                $location.path('/trades/bid/request/edit');
                new_codes = null;
            })
        };

        $scope.goToWizard = function (item) {
            if(!item.project_name) {
                item.project_name = item.bid_name;
            }
            BidWizardEdit.set(item);
        };

        $scope.addBid = function () {
            if (!this.bid_name) this.bid_name = [];
            console.log('In the add bids');

            var shortDate = $filter('date')(new Date(), 'short');
            var bid = new Bids({
                bid_name: this.bid_name,
                builder_info: $scope.trade,
                bid_status: 'new',
                trade_id: $scope.trade._id,
                project_name: this.bid_name,
                project_start_date: shortDate
            });
            console.log('In the add bids', bid);
            bid.$save(function (response) {
                $scope.new_bids.push(response);

                BidWizardEdit.set(response);
                $location.path('/trades/bid/wizard');
            });
        };

        $scope.remove = function (bid) {
            if (!$scope.is_admin) {
                alert('You must have admin rights to remove a bid.');
                return;
            }

            for (var i in $scope.new_bids) {
                if ($scope.new_bids[i] === bid) {
                    $scope.new_bids.splice(i, 1);
                }
            }

            bid.$remove();

            //var data = $scope.new_bids;
            //$scope.newBidTableParams.total(data.length);
            //$scope.newBidTableParams.reload();
        };

        $scope.removeBid = function (id) {
            if (!$scope.is_admin) {
                alert('You must have admin rights to remove a bid.');
                return;
            }
            //new_bids already have a delete function.  This will be for
            //submitted and review bids.  The delete will be coming from
            //the associated lists modal.

            $scope.trade.main_account_id.username

            var bid = $filter('filter')($scope.submitted_bids, { '_id': id }, true);
            if (bid.length === 1) {
                var me = $filter('filter')(bid[0].bidding_trades, {
                    'username': $scope.trade.main_account_id.username
                }, true);

                if (me.length === 1) {
                    TradeBids.query({ '_id': me[0]._id }, function (trade_bid) {
                        if (trade_bid.length !== 1) {
                            toaster.pop('error', 'Trade',
                                'There is a problem getting the bid trade from the database');
                            return;
                        }
                        trade_bid[0].trade_declined = true;
                        trade_bid[0].date_declined = new Date();
                        trade_bid[0].$update(function (success) {
                            var idx = $scope.submitted_bids.indexOf(bid[0]);
                            if (idx === -1) {
                                toaster.pop('error', 'Could Not Find The Bid',
                                    'Please reload the page to update the bid list.');
                            } else {
                                $scope.submitted_bids.splice(idx, 1);
                            }
                        });
                    });
                }
            }
            // for (var i in $scope.review_bids) {
            //     if ($scope.review_bids[i]._id === id) {
            //         var bid = $scope.review_bids.splice(i, 1)
            //         if(bid.length === 1) {
            //             //bid[0].$remove();
            //         } else {
            //             alert('More than one bid returned for deletion.  Contact Admin.');
            //         }
            //         return;
            //     }
            // }
        };

        $scope.editOperation = function (id) {
            ngDialog.openConfirm({
                template:
                    '<h2>Edit Bid Data</h2>' +
                    '<p>This operation will allow you to update bid data and send the bid through the normal process.  Once accepted, all new lots will take the updated values</p>' +
                    '<p>Are you sure you want to edit this bid? </p>' +
                    '<div class="row"><div class="col-lg-4">' +
                    '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">Cancel</button>' +
                    '</div>' +
                    // '<div class="col-lg-4">' +
                    //   '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Keep Totals</button>' +
                    // '</div>' +
                    '<div class="col-lg-4">' +
                    '<button type="button" class="btn btn-primary" ng-click="confirm(2)">Full Edit</button>' +
                    '</div></div>',
                plain: true,
                className: 'ngdialog-theme-default'
            }).then(function (value) {
                if (value === 2) {
                    $scope.editBid(id);
                }
            }, function (value) {
                console.log('in the do something section');
            });
        };

        $scope.editBid = function (id) {
            if (!$scope.is_admin) {
                alert('You must have admin rights to delete a bid.');
                return;
            }

            for (var i in $scope.project_bids) {
                if ($scope.project_bids[i]._id === id) {
                    var bid = $scope.project_bids.splice(i, 1);
                    if (bid.length === 1) {
                        bid[0].bid_status = 'submitted';
                        bid[0].in_bidder_revision = true;
                    } else {
                        alert('More than one bid returned for deletion.  Contact Admin.');
                        return;
                    }

                    var trade = $filter('filter')(bid[0].bidding_trades, {
                        'username': $scope.trade.main_account_id.username
                    }, true);

                    if (trade.length !== 1) {
                        toaster.pop('error', 'Trade Error', 'Cannot get the trade from the bid.  Contact admin.');
                        return;
                    }

                    TradeBids.query({ '_id': trade[0]._id }, function (trade_bid) {
                        if (!trade_bid[0].revisions)
                            trade_bid[0].revisions = [];

                        var number = trade_bid[0].revisions.length + 1;

                        trade_bid[0].revisions.push({
                            number: number,
                            date_completed: new Date(trade_bid[0].date_completed),
                            inclusions: angular.copy(trade_bid[0].inclusions),
                            exclusions: angular.copy(trade_bid[0].exclusions),
                            costs: angular.copy(trade_bid[0].costs),
                            overrides: angular.copy(trade_bid[0].overrides),
                            extra_liability: angular.copy(trade_bid[0].extra_liability),
                            bid: angular.copy(trade_bid[0].bid)
                        });

                        trade_bid[0].date_completed = new Date();
                        trade_bid[0].in_revision = true;
                        trade_bid[0].accepted = false;
                        trade_bid[0].trade_declined = false;
                        trade_bid[0].first_process = false;
                        trade_bid[0].submitted = 'false';

                        trade_bid[0].$update(function (success) {
                            bid[0].$update(function (success) {
                                success.builder = (success.builder_id) ?
                                    success.builder_id.name : $scope.trade.name;

                                $scope.submitted_bids.push(success);
                                return;
                            });
                        });
                    });
                }
            }
        };

        $scope.deleteOperation = function (id) {
            ngDialog.openConfirm({
                template:
                    '<h2>Delete Bid Data</h2>' +
                    '<p>This operation will delete all bid data from the system</p>' +
                    '<p>Are you sure you want to delete this bid? </p>' +
                    '<div>' +
                    '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;' +
                    '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                    '</button></div>',
                plain: true,
                className: 'ngdialog-theme-default'
            }).then(function (value) {
                // perform delete operation
                $scope.deleteBid(id);
            }, function (value) {
                //Do something
                console.log('in the do something section');
            });
        };

        $scope.deleteBid = function (id) {
            console.log('in deleteBid function with id ' + id);
            if (!$scope.is_admin) {
                alert('You must have admin rights to delete a bid.');
                return;
            }

            for (var i in $scope.project_bids) {
                if ($scope.project_bids[i]._id === id) {
                    var bid = $scope.project_bids.splice(i, 1);
                    if (bid.length === 1) {
                        bid[0].$remove();
                    } else {
                        alert('More than one bid returned for deletion.  Contact Admin.');
                    }
                    return;
                }
            }
        };

        $scope.reopenProject = function (id) {
            var bid = $filter('filter')($scope.complete, { '_id': id }, true);
            if (bid.length !== 1) {
                toaster.pop('error', 'Bid Error', 'Could not find bid in list.  Contact admin.');
                return;
            }

            if (!bid[0].project_id || bid[0].project_id === 0) {
                toaster.pop('error', 'Bid Error', 'Bid is not associated with a project.  Contact admin.');
                return;
            }

            bid[0].bid_status = 'project';
            bid[0].complete = false;
            bid[0].$update(function (success) {
                projectCompleteService.setComplete(false, success.project_id);
                $location.path('/');
            }, function (error) {
                toaster.pop('error', 'Bid Update Error', error);
            });
        };

        $scope.reopenProjectOperation = function (id) {
            ngDialog.openConfirm({
                template:
                    '<h2>Reopen Project</h2>' +
                    '<p>This operation will make the project data available for tracking and submitting time and materials.</p>' +
                    '<p>Are you sure you want to continue? </p>' +
                    '<div>' +
                    '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;' +
                    '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                    '</button></div>',
                plain: true,
                className: 'ngdialog-theme-default'
            }).then(function (value) {
                // perform delete operation
                $scope.reopenProject(id);
            }, function (value) {
                //Do something
                console.log('in the do something section');
            });
        };

        $scope.padDigits = function (number, digits) {
            return Array(Math.max(digits - String(number).length + 1, 0)).join(0) + number;
        }

        $scope.acceptBid = function () {
            var bid = $scope.builder_bids[$scope.current_review_bid];

            var bid_trades = [];
            var plan_codes = [];
            var tasks = [];
            var plans = [];

            console.log('in tradeBids acceptBid');

            toaster.pop('error', 'System Error', 'Contact Admin');


            // bid.bidding_trades.forEach(function(bidder, idx) {
            //     var trade = $filter('filter')(company_factors, {trade_name: bidder.trade})[0];
            //     bid_trades.push({
            //         name: bidder.trade,
            //         manager: {
            //             name: bidder.name,
            //             username: bidder.username,
            //             phone: bidder.phone,
            //             email: bidder.email
            //         },
            //         supplier: bidder.supplier,
            //         equipment_supplier: bidder.equipment_supplier,
            //         inclusions: bidder.inclusions,
            //         exclusions: bidder.exclusions,
            //         company_factors: $scope.trade
            //     });
            // });

            // tasks = [];
            // var days_off = 0;
            // bid.task_list.forEach(function(task, ii) {
            //     var subs = [];
            //     task.subtasks.forEach(function(sub) {
            //         subs.push({
            //             name: sub.name
            //         });
            //     });

            //     tasks.push({
            //         name: task.name,
            //         order: task._id,
            //         task: task.task,
            //         hours: 8.0,
            //         days: 1.0,
            //         days_offset: days_off,
            //         trade: task.trade,
            //         subtasks: subs
            //     });

            //     days_off += 1;
            // });

            // plans.push({
            //     item: 'Standard',
            //     task_list: tasks
            // });

            // var trade_code = userService.getTradeCode($scope.user.username);

            // ProjectJobs.query({'company_code': $scope.trade.company_code, 'trade_code': trade_code}, function(jobs) {
            //     var new_job_code = '';

            //     if(jobs.length === 1) {
            //         new_job_code = $scope.padDigits(jobs[0].current_value, 4);
            //         jobs[0].current_value = jobs[0].current_value + 1;
            //         if(jobs[0].current_value === 10000) jobs[0].current_value = 1;
            //         jobs[0].$update();
            //     } else if(jobs.length === 0) {
            //         var new_job = new ProjectJobs({
            //             company_code: $scope.trade.company_code,
            //             trade_code: trade_code,
            //             current_value: 2
            //         });
            //         new_job_code = $scope.padDigits(1, 4);
            //         new_job.$save();
            //     } else if(jobs.length > 1) {
            //         alert('More than one contractor/division combination came back.  Call admin.');
            //         return;
            //     }

            //     var project = new Projects({
            //         name: bid.project_name,
            //         projectBidId: bid._id,
            //         job_code: new_job_code,
            //         contact: {
            //             name: bid.purchasing_agent_name,
            //             address_one: bid.project_address,
            //             address_two: '',
            //             city: bid.project_city,
            //             state: bid.project_state,
            //             zip: bid.project_zip,
            //             timezone: bid.project_timezone,
            //             email: bid.purchasing_agent_email,
            //             phone: bid.purchasing_agent_phone_number
            //         },
            //         builder: {
            //             name: bid.builder_name,
            //             division: bid.builder_division,
            //             address_one: bid.builder_address_one,
            //             address_two: bid.builder_address_two,
            //             city: bid.builder_city,
            //             state: bid.builder_state,
            //             zip: bid.builder_zip,
            //             email: bid.builder_email,
            //             phone: bid.builder_phone_number
            //         },
            //         mtc: {
            //             name: bid.mtc_name,
            //             code: bid.mtc_code,
            //             division: bid.mtc_division,
            //             president_name: bid.mtc_president_name,
            //             president_phone_number: bid.mtc_president_phone_number,
            //             president_email: bid.mtc_president_email,
            //             division_manager_name: bid.mtc_division_manager_name,
            //             division_manager_phone_number: bid.mtc_division_manager_phone_number,
            //             division_manager_email: bid.mtc_division_manager_email
            //         },
            //         project_type: bid.project_type,
            //         plan_codes: plan_codes,
            //         trades: bid_trades,
            //         plan: plans,
            //         mainAccountId: $scope.main_account_id
            //     });

            //     project.$save(function(saved) {

            //         console.log('project save came back with ' + saved._id);
            //         if(optionSaveService.updateProjectIdFromBidId(bid._id, saved._id)) {
            //             return;
            //         }

            //         bid.bidding_trades.forEach(function(bidder, idx) {
            //             var trade = $filter('filter')(company_factors, {trade_name: bidder.trade}, true)[0];

            //             $scope.company_factors = trade;
            //             saved.plan_codes.forEach(function(plan) {
            //                 var tasks = $filter('filter')(bidder.bid, {plan_code: plan.item}, true);

            //                 tasks.forEach(function(task, ii) {
            //                     var cp_task = $filter('filter')(bid.task_list, {_id: task.task_id}, true);
            //                     if(cp_task.length !== 1)
            //                         alert('There is an issue getting the task');

            //                     task.subtasks.forEach(function(sub, ij) {
            //                         sub.crew_rate = cp_task[0].subtasks[ij].crew_rate;
            //                         sub.piece_per_hour_rate = cp_task[0].subtasks[ij].piece_per_hour_rate;
            //                         sub.piece_rate = cp_task[0].subtasks[ij].piece_rate;
            //                         sub.unit = cp_task[0].subtasks[ij].unit;
            //                     });

            //                     task.materials.forEach(function(mat, ij) {
            //                         mat.supplier = cp_task[0].materials[ij].supplier;
            //                     });

            //                     task.equipment.forEach(function(eq, ij) {
            //                         eq.supplier = cp_task[0].equipment[ij].supplier;
            //                     });
            //                 });
            //                 //before applying the calcs, get the piece rates and stuff from the task list
            //                 $scope.applayCalculations(tasks);

            //                 //now we have all the calculations for a given plan, so lets save them
            //                 //off into the projectBids database
            //                 tasks.forEach(function(task) {
            //                     var cp_task = $filter('filter')(bid.task_list, {_id: task.task_id}, true)[0];
            //                     if(!cp_task) {
            //                         alert('Could not get the task from the bid.task_list.  Call admin.');
            //                         return;
            //                     }
            //                     var sub_arr = [];
            //                     var mat_arr = [];
            //                     var eq_arr = [];

            //                     //build the subtask array
            //                     task.subtasks.forEach(function(sub, ii) {
            //                         sub_arr.push({
            //                             task_id: sub.task_id,
            //                             name: cp_task.subtasks[ii].name,
            //                             crew_rate: sub.crew_rate,
            //                             current_net_pay: sub.current_net_pay,
            //                             employee_benefits: sub.employee_benefits,
            //                             piece_per_hour_rate: sub.piece_per_hour_rate,
            //                             piece_rate: sub.piece_rate,
            //                             unit: sub.unit,
            //                             bid_hours: sub.bid_hours,
            //                             hours_allowed: sub.hours_allowed,
            //                             training_and_education: sub.training_and_education,
            //                             quantity: sub.quantity,
            //                             labor_total: sub.labor,
            //                             bid_mark_up: sub.bid_mark_up,
            //                             general_liability: sub.general_liability,
            //                             material_total: sub.material_total,
            //                             materials_subtotal: sub.materials_subtotal,
            //                             materials_dev_subtotal: sub.materials_dev_subtotal,
            //                             equipment_total: sub.equipment_total,
            //                             equipment_subtotal: sub.equipment_subtotal,
            //                             equipment_dev_subtotal: sub.equipment_dev_subtotal,
            //                             total: sub.total,
            //                             work_comp: sub.work_comp
            //                         });
            //                     });

            //                     task.materials.forEach(function(mat, ii) {
            //                         mat_arr.push({
            //                             name: cp_task.materials[ii].name,
            //                             material_id: mat.material_id,
            //                             supplier: mat.supplier,
            //                             quantity: mat.quantity,
            //                             price_per_order: mat.price_per_order,
            //                             piece_per_size: mat.piece_per_size,
            //                             delivery_price: mat.delivery_price,
            //                             delivery_offset: cp_task.materials[ii].delivery_offset,
            //                             description: cp_task.materials[ii].description,
            //                             note: cp_task.materials[ii].note,
            //                             unit: cp_task.materials[ii].unit
            //                         });
            //                     });

            //                     task.equipment.forEach(function(eq, ii) {
            //                         eq_arr.push({
            //                             name: cp_task.equipment[ii].name,
            //                             equipment_id: eq.equipment_id,
            //                             supplier: eq.supplier,
            //                             quantity: eq.quantity,
            //                             price_per_order: eq.price_per_order,
            //                             piece_per_size: eq.piece_per_size,
            //                             delivery_price: eq.delivery_price,
            //                             delivery_offset: cp_task.equipment[ii].delivery_offset,
            //                             description: cp_task.equipment[ii].description,
            //                             note: cp_task.equipment[ii].note,
            //                             unit: cp_task.equipment[ii].unit
            //                         });
            //                     });

            //                     var override = $filter('filter')(bid.overrides, {
            //                         'plan_code': task.plan_code, 'enabled': true }, true);

            //                     var offset_total = 0;
            //                     var mark_up = task.bid_mark_up
            //                     //only adjust override total on the first task
            //                     if(override.length === 1 && itr === 0) {
            //                         offset_total = override[0].amount - override[0].original_amount;
            //                         mark_up = override[0].amount;
            //                     }

            //                     var extra_liability = $filter('filter')(bid.extra_liability, {
            //                         'plan_code': task.plan_code, 'enabled': true }, true);

            //                     if(extra_liability.length === 1 && itr === 0) {
            //                         task.bid_general_liability += extra_liability[0].amount;
            //                         task.total += extra_liability[0].amount;
            //                     }

            //                     var proBid = new ProjectBids({
            //                         task_name: cp_task.name,
            //                         trade: $scope.getTradeString(cp_task.trade),
            //                         project_id: saved._id,
            //                         task_code: cp_task.trade + cp_task.task,
            //                         plan_code: task.plan_code,
            //                         days: 1.0,
            //                         hours: 8.0,
            //                         days_offset: task.task_id - 1,
            //                         task_id: task.task_id,
            //                         totals: {  //task totals computed during bid phase (during accepting)
            //                             total: task.total + offset_total,
            //                             labor: task.total_labor,
            //                             materials: task.total_materials,
            //                             materials_subtotal: task.materials_subtotal,
            //                             materials_dev_subtotal: task.materials_dev_subtotal,
            //                             equipment: task.total_equipment,
            //                             equipment_subtotal: task.equipment_subtotal,
            //                             equipment_dev_subtotal: task.equipment_dev_subtotal,
            //                             current_net_pay: task.total_current_net_pay,
            //                             general_liability: task.bid_general_liability,
            //                             mark_up: mark_up,
            //                             work_comp: task.work_comp,
            //                             hours_allowed: task.total_hours_allowed
            //                         },
            //                         subtasks: sub_arr,
            //                         materials: mat_arr,
            //                         equipment: eq_arr
            //                     });

            //                     proBid.$save();
            //                 });
            //             })

            //         });

            //         bid.project_id = saved._id;
            //         bid.bid_status = 'project';
            //         bid.$update();
            //     });
            // });

            // $location.path('project admin');
        };

        $scope.viewBidDetails = function (bid) {
            $scope.details_bid_id = $scope.details_bid_name = $scope.details_builder =
                $scope.details_return_date = $scope.details_days_remaining = '';
            //here we can use the bid.bidding_trades to
            //get details on who is done and who is not.
            $scope.bid = bid;
            if (bid.builder_id) {
                //This is a builder submitted bid so get the info needed
                Builders.query({ '_id': bid.builder_id._id }, function (builders) {
                    if (builders.length !== 1) return;

                    $scope.details_bid_id = bid._id;
                    $scope.details_bid_name = bid.bid_name;
                    $scope.details_builder = builders[0];
                    $scope.details_return_date = bid.bid_date_requested;
                    //$scope.details_options = bid.options.length;
                    var today = moment(new Date());
                    var requested = moment(new Date(bid.bid_date_requested));

                    console.log('today: ' + today.format('DD-MM-YYYY') +
                        ', requested: ' + requested.format('DD-MM-YYYY') +
                        ', difference: ' + Math.floor(moment.duration(requested.diff(today)).asDays()));

                    $scope.details_days_remaining =
                        Math.floor(moment.duration(requested.diff(today)).asDays());
                });
            } else {
                $scope.details_bid_id = bid._id;
                $scope.details_bid_name = bid.bid_name;
                $scope.details_builder = $scope.trade;
                $scope.details_return_date = bid.bid_date_requested;
                //$scope.details_options = bid.options.length;
                var today = moment(new Date());
                var requested = moment(new Date(bid.bid_date_requested));

                console.log('today: ' + today.format('DD-MM-YYYY') +
                    ', requested: ' + requested.format('DD-MM-YYYY') +
                    ', difference: ' + Math.floor(moment.duration(requested.diff(today)).asDays()));

                $scope.details_days_remaining =
                    Math.floor(moment.duration(requested.diff(today)).asDays());
            }
        };
        // function DialogController($scope, $mdDialog) {
        //     $scope.hide = function() {
        //       $mdDialog.hide();
        //     };

        //     $scope.cancel = function() {
        //       $mdDialog.cancel();
        //     };

        //     $scope.answer = function(answer) {
        //       $mdDialog.hide(answer);
        //     };
        // }

        // $scope.viewBidDetails = function(ev , index){
        //     $scope.details_bid_id = $scope.details_bid_name = $scope.details_builder =
        //     $scope.details_return_date = $scope.details_days_remaining = '';
        //     //here we can use the $scope.submitted_bids[index].bidding_trades to
        //     //get details on who is done and who is not.
        //     if($scope.submitted_bids[index].builder_id) {
        //         //This is a builder submitted bid so get the info needed
        //         Builders.query({'_id': $scope.submitted_bids[index].builder_id._id}, function(builders) {
        //             if(builders.length !== 1) return;

        //             $scope.details_bid_id = $scope.submitted_bids[index]._id;
        //             $scope.details_bid_name = $scope.submitted_bids[index].bid_name;
        //             $scope.details_builder = builders[0];
        //             $scope.details_return_date = $scope.submitted_bids[index].bid_date_requested;
        //             var today = moment(new Date());
        //             var requested = moment(new Date($scope.submitted_bids[index].bid_date_requested));

        //             console.log('today: ' + today.format('DD-MM-YYYY') +
        //                 ', requested: ' + requested.format('DD-MM-YYYY') +
        //                 ', difference: ' + Math.floor(moment.duration(requested.diff(today)).asDays()));

        //             $scope.details_days_remaining = Math.floor(moment.duration(requested.diff(today)).asDays());
        //         });
        //     } else {
        //         $scope.details_bid_id = $scope.submitted_bids[index]._id;
        //         $scope.details_bid_name = $scope.submitted_bids[index].bid_name;
        //         $scope.details_builder = $scope.trade;
        //         $scope.details_return_date = $scope.submitted_bids[index].bid_date_requested;
        //         var today = moment(new Date());
        //         var requested = moment(new Date($scope.submitted_bids[index].bid_date_requested));

        //         console.log('today: ' + today.format('DD-MM-YYYY') +
        //             ', requested: ' + requested.format('DD-MM-YYYY') +
        //             ', difference: ' + Math.floor(moment.duration(requested.diff(today)).asDays()));

        //         $scope.details_days_remaining = Math.floor(moment.duration(requested.diff(today)).asDays());

        //         // $mdDialog.show({
        //         //   controller: DialogController,
        //         //   templateUrl: 'bids/views/tmpl/request.dialog.html',
        //         //   parent: angular.element(document.body),
        //         //   targetEvent: ev,
        //         //   clickOutsideToClose:true
        //         // })
        //         //     .then(function(answer) {
        //         //       $scope.status = 'You said the information was "' + answer + '".';
        //         //     }, function() {
        //         //       $scope.status = 'You cancelled the dialog.';
        //         //     });

        //         // ngDialog.open({
        //         //     template: 'bids/views/tmpl/request.dialog.html',
        //         //     scope: $scope,
        //         //     className: 'ngdialog-theme-default'
        //         // });

        //         // .then(function (value) {
        //         //     //$scope.addMaterialReport();
        //         // }, function (value) {
        //         //     //Do something
        //         //     console.log('in the do something section');
        //         // });

        //         $mdDialog.show(
        //           $mdDialog.alert()
        //             .parent(angular.element(document.querySelector('#popupContainer')))
        //             .clickOutsideToClose(true)
        //             .title('This is an alert title')
        //             .textContent('This really sucks that I have to use this fucker.')
        //             .ariaLabel('Alert Dialog Demo')
        //             .ok('Got it!')
        //             .targetEvent(ev)
        //         );
        //     }
        // };

        $scope.viewBidReviewDetails = function (bid) {
            //here we can use the $scope.submitted_bids[index].bidding_trades to
            //get details on who is done and who is not.
            $scope.bid = bid;
            $scope.details_bid_id = bid._id;
            $scope.details_bid_name = bid.bid_name;
            $scope.details_bidding_trades = bid.bidding_trades;
            if (bid.trade_id)
                $scope.my_trade_bid = true;
            //set the index so we know which bid is getting selected
            $scope.current_review_bid = $scope.review_bids.indexOf(bid);
        };

        $scope.viewBidBuilderDetails = function (bid) {
            //here we can use the $scope.submitted_bids[index].bidding_trades to
            //get details on who is done and who is not.
            $scope.bid = bid;
            $scope.details_bid_id = bid._id;
            $scope.details_bid_name = bid.bid_name;
            $scope.details_bidding_trades = bid.bidding_trades;
            if (bid.trade_id)
                $scope.my_trade_bid = true;
            //set the index so we know which bid is getting selected
            $scope.current_review_bid = $scope.builder_bids.indexOf(bid);
        };

        // $scope.viewBidProjectDetails = function(bid){
        //     //here we can use the $scope.submitted_bids[index].bidding_trades to
        //     //get details on who is done and who is not.
        //     $scope.details_bid_id = bid._id;
        //     $scope.details_bid_name = bid.bid_name;
        //     $scope.details_bidding_trades = bid.bidding_trades;
        //     if(bid.trade_id)
        //         $scope.my_trade_bid = true;
        //     //set the index so we know which bid is getting selected
        //     $scope.current_review_bid = $scope.project_bids.indexOf(bid);
        // };

        $scope.viewBidProjectDetails = function (bid) {
            //here we can use the $scope.submitted_bids[index].bidding_trades to
            //get details on who is done and who is not.
            $scope.bid = bid;
            $scope.details_bid_id = bid._id;
            $scope.details_bid_name = bid.bid_name;
            $scope.details_bidding_trades = bid.bidding_trades;
            if (bid.trade_id)
                $scope.my_trade_bid = true;
            //set the index so we know which bid is getting selected
            $scope.current_review_bid = $scope.rejected_bids.indexOf(bid);
        }

        $scope.viewCompletedProjectDetails = function (bid) {
            //here we can use the $scope.submitted_bids[index].bidding_trades to
            //get details on who is done and who is not.
            $scope.bid = bid;
            $scope.details_bid_id = bid._id;
            $scope.details_bid_name = bid.bid_name;
            $scope.details_bidding_trades = bid.bidding_trades;
            if (bid.trade_id)
                $scope.my_trade_bid = true;
            //set the index so we know which bid is getting selected
            $scope.current_review_bid = $scope.complete.indexOf(bid);
        };

        $scope.reviewBid = function (bid) {
            //select the bid and pass it into set with the bid index to be reviewed.
            BidRequestReview.set($scope.builder_bids[$scope.current_review_bid], bid);
        };

        $scope.changeBidAcceptance = function () {
            var bid = $scope.rejected_bids[$scope.current_review_bid];
            //bid.bidding_trades[0].accepted = true;
            TradeBids.query({ '_id': bid.bidding_trades[0]._id }, function (trade_bids) {
                if (trade_bids.length !== 1) {
                    toaster.pop('error', 'Trade Bid Error',
                        'Problem getting trade bid from database.  Contact admin.');
                    return;
                }

                trade_bids[0].accepted = true;
                trade_bids[0].$update(function (success) {
                    $scope.rejected_bids.splice($scope.current_review_bid, 1);
                    bid.bidding_trades[0] = success;
                    $scope.project_bids.push(bid);
                }, function (error) {
                    toaster.pop('error', 'Bid Update Error', error);
                });
            });
        };

        $scope.removeBidFromSystems = function (bid) {
            var bidIdx = $scope.rejected_bids.indexOf(bid);

            TradeBids.query({ '_id': bid.bidding_trades[0]._id }, function (trade_bids) {
                if (trade_bids.length !== 1) {
                    toaster.pop('error', 'Trade Bid Error',
                        'Problem getting trade bid from database.  Contact admin.');
                    return;
                }

                trade_bids[0].$delete(function (success) {
                    //TradeBid is removed.  See if this is my
                    //companies bid and remove if needed.
                    if (bid.trade_id) {
                        bid.$delete()
                    }

                    $scope.rejected_bids.splice(bidIdx, 1);
                }, function (error) {
                    toaster.pop('error', 'Bid Update Error', error);
                });
            });
        };

        $scope.moveBidBackToProject = function (bid) {
            if (bid.builder_id) {
                toaster.pop('error', 'Cannot Undo Reject Status',
                    'Only the builder can perform this operation');
                return;
            }

            var bidIdx = $scope.rejected_bids.indexOf(bid);

            TradeBids.query({ '_id': bid.bidding_trades[0]._id }, function (trade_bids) {
                if (trade_bids.length !== 1) {
                    toaster.pop('error', 'Trade Bid Error',
                        'Problem getting trade bid from database.  Contact admin.');
                    return;
                }

                trade_bids[0].rejected = false;
                trade_bids[0].$update(function (success) {
                    toaster.pop('success', 'Database Updated');
                    $location.path('/');
                }, function (error) {
                    toaster.pop('error', 'Bid Update Error', error);
                });
            });
        };

        $scope.moveBidBackToRequest = function () {
            var bid = $scope.builder_bids[$scope.current_review_bid];

            var builder_name = (bid.builder_id) ? bid.builder_id.name : bid.trade_id.name;

            TradeBids.query({ '_id': bid.bidding_trades[0]._id }, function (trade_bids) {
                if (trade_bids.length !== 1) {
                    toaster.pop('error', 'Trade Bid Error',
                        'Problem getting trade bid from database.  Contact admin.');
                    return;
                }

                trade_bids[0].accepted = false;
                trade_bids[0].submitted = false;
                trade_bids[0].$update(function (success) {
                    bid.bid_status = 'submitted';
                    bid.$update(function (success) {
                        toaster.pop('success', 'Database Updated');
                        $scope.builder_bids.splice($scope.current_review_bid, 1);
                        success.builder = builder_name;

                        var bid = success;
                        if (bid.plan_codes.length) {
                            bid.number_of_units = 0;
                            for (var j = 0; j < bid.plan_codes.length; j++) {
                                if (bid.plan_codes[j].quantity)
                                    bid.number_of_units += bid.plan_codes[j].quantity;
                            }

                            if (bid.bidding_trades[0].first_process) {
                                bid.status_text = 'Untouched';
                            } else {
                                bid.status_text = 'In Progress';
                            }

                            var req_date = moment(bid.bid_date_requested);
                            var today = moment();
                            bid.days_diff = req_date.diff(today, 'days');

                            if (bid.days_diff >= 7) {
                                bid.status_color = 'green';
                            } else if (bid.days_diff >= 0) {
                                bid.status_color = 'yellow';
                            } else {
                                bid.status_color = 'red';
                            }
                        }
                        $scope.submitted_bids.push(bid);
                    }, function (error) {
                        toaster.pop('error', 'Bid Update Error', error);
                    });
                }, function (error) {
                    toaster.pop('error', 'Bid Update Error', error);
                });
            });
        };

        $scope.submitToBuilder = function () {
            var bid = $scope.review_bids[$scope.current_review_bid];

            //update bid status and send to database
            bid.bid_status = 'builder_review';
            bid.$update();

            //move bid from review_bids to builder_bids
            $scope.builder_bids.push(bid);
            $scope.review_bids.splice($scope.current_review_bid, 1);

            var data = ({
                builderName: bid.builder_name,
                builderEmail: bid.builder_email,
                builderSubject: bid.project_name + ' is ready for your review.',
                builderMessage: bid.builder_name + ', please log in to http://ec2-54-183-70-119.us-west-1.compute.amazonaws.com/ and review ' + bid.bid_name + '.  <br>Please contact Brandon Wilson after you\'ve had a chance to review to set up a start date for your new project.'
            });

            $http.post('/api/sendBuilderEmail', data).
                success(function (data, status, headers, config) {
                    console.log('Message to builder was successfully sent');
                }).
                error(function (data, status, headers, config) {
                    console.log('There was an error with the message');
                });
        };

        $scope.rejectBid = function () {
            //console.log('in the rejectBid function' + $scope);
            var bid = $scope.builder_bids[$scope.current_review_bid];
            TradeBids.query({ 'bid_id': bid._id }, function (trade_bid) {
                //trade_bid[0].submitted = false;
                trade_bid[0].accepted = false;
                trade_bid[0].rejected = true;
                trade_bid[0].date_rejected = new Date();
                trade_bid[0].$update(function (success) {
                    toaster.pop('success', 'Database Updated');
                    $location.path('/');
                    //bid.bid_status = 'project';
                    // bid.$update(function(success) {
                    //     toaster.pop('success', 'Database Updated');
                    //     $location.path('/');
                    // }, function(error) {
                    //     toaster.pop('error', 'Bid Update Error', error);
                    // });
                }, function (error) {
                    toaster.pop('error', 'TradeBid Update Error', error);
                });
            });
        };

        $scope.returnedEmail = function () {
            console.log('email has been sent');
        };

        $scope.getProgress = function (bid) {
            var today = new Date();
            var requested = new Date(bid.bid_date_requested);
            requested.setDate(requested.getDate() - today.getDate());
            var diff = requested.getDate();
            if (diff < 1) {
                bid.progress_type = 'danger';
            } else if (diff < 3) {
                bid.progress_type = 'warning';
            } else {
                bid.progress_type = 'success';
            }

            return bid.bid_request_progress;
        };

        $scope.getProgressType = function (bid) {
            return 'warning';
        };

        $scope.submitBid = function (bid) {
            if (!bid.bid_date_requested) {
                alert('Trade Manager submission date not set');
                return;
            }

            if (bid.task_list.length === 0) {
                alert('Task list is not attached');
                return;
            }

            if (bid.bidding_trades.length === 0) {
                alert('No bidding trades selected');
                return;
            }

            if (!bid.project_type) {
                alert('Select a project type');
                return;
            }

            if (bid.project_type === 'single') {
                if (bid.plan_codes.length === 0) {
                    alert('You must add at least one plan/elevation for a single family project');
                    return;
                }
            }

            for (var i in $scope.new_bids) {
                if ($scope.new_bids[i] === bid) {
                    $scope.new_bids.splice(i, 1);
                }
            }

            bid.bid_status = 'submitted';
            bid.$update();

            for (var j = 0; j < bid.bidding_trades.length; j = j + 1) {
                NotifyService.addNotification(bid.bidding_trades[j].username, 'toast-info', 'New Bid', 'There is a new bid request for you to fill out and return', 'No');
            }
            $scope.$broadcast('notificationAdded');
            $scope.submitted_bids.push(bid);

            //var data = $scope.new_bids;
            //$scope.newBidTableParams.total(data.length);
            //$scope.newBidTableParams.reload();
        };

        $scope.viewBidBuilderReview = function (index) {
            BidBuilderReview.set($scope.builder_bids[$scope.current_review_bid]);
            //BidBuilderReview.set($scope.my_review_bids[index]);
            $location.path('builder/bids/multi/review');
        };

        $scope.currentNetPay = function (bid_hours, crew_rate, quantity, piece_rate) {
            var val = 0;

            if (bid_hours > 0) {
                val = bid_hours * crew_rate;
            } else {
                val = quantity * piece_rate;
            }

            return val;
        };

        $scope.directLaborCosts = function (bid_hours, quantity, ali_crew_rate) {
            var val = 0;
            if (bid_hours === 0) {
                val = quantity * ali_crew_rate;
            } else {
                val = bid_hours * ali_crew_rate;
            }

            return val;
        };

        $scope.aliCrewRate = function (bid_hours, piece_rate, crew_rate, ali_crew_net_pay) {
            var val = 0;

            if (bid_hours === 0) {
                val = piece_rate * ali_crew_net_pay;
            } else {
                val = crew_rate * ali_crew_net_pay;
            }

            return val;
        };

        $scope.aliCrewNetPay = function (direct_labor_costs, training_and_education) {
            return direct_labor_costs - training_and_education;
        };

        // $scope.increasePay = function(ali_crew_net_pay, current_net_pay) {
        //     return ali_crew_net_pay - current_net_pay;
        // };

        $scope.hoursAllowed = function (bid_hours, current_net_pay, crew_rate) {
            var temp_value = 0;

            if (!bid_hours) bid_hours = 0;
            if (!current_net_pay) current_net_pay = 0;
            if (!crew_rate) crew_rate = 0;

            if (bid_hours === 0) {
                if (crew_rate)
                    temp_value = (current_net_pay / crew_rate);
                else
                    temp_value = 0;
            } else {
                temp_value = bid_hours;
            }

            return $filter('number')(temp_value, 2);
        };

        $scope.trainingAndEducation = function (hours_allowed, training_and_education) {
            return hours_allowed * training_and_education;
        };

        $scope.employeeBenefits = function (hours_allowed, benefits) {
            return hours_allowed * benefits;
        };

        $scope.applayCalculations = function (tasks) {
            taskTotalsService.getCalculations(tasks, $scope.company_factors);
        };

        $scope.viewBidOldDetails = function () {
            var bid = $filter('filter')($scope.project_bids, { '_id': $scope.details_bid_id }, true);
            if (bid.length !== 1) {
                alert('There is a problem with getting the old bid for review.  Contact Admin!');
                return;
            }
            BidOldReview.set(bid[0]);
            $location.path('old/details');
        };

        $scope.getTradeCode = function (trade) {
            return tradeCodeService.getCode(trade);
        };

        $scope.getTradeString = function (trade) {
            return tradeCodeService.getName(trade);
        };
    }
]);



// WEBPACK FOOTER //
// ./packages/custom/trades/public/controllers/tradesBid.js